export default "__VITE_PUBLIC_ASSET__8f90f0ad__"